import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentInvoiceFilter',
  pure: false
})
export class SentInvoiceFilterPipe implements PipeTransform {
  transform(items: any[]): any {
    if (items == null) {
      return items;
    }
    return items.filter(item => item.teamleaderId != null);
  }
}
